var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { staticClass: "container", attrs: { role: "main" } },
    [
      _c(
        "article",
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col" }, [
              _c(
                "a",
                {
                  staticClass: "portal-back",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.$router.go(-1)
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "fas fa-chevron-left",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _c("span", { staticClass: "back-link" }, [
                    _vm._v(_vm._s(_vm.$t("components.actions.back"))),
                  ]),
                ]
              ),
            ]),
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("employee-list-field", {
                  attrs: {
                    form: _vm.form,
                    name: "employee",
                    initValue: _vm.initialEmployeeCode,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm.$isset(_vm.form.employee)
            ? [
                _c(
                  "div",
                  { staticClass: "d-flex pb-2 table-responsive" },
                  [
                    _vm.activeHoursPack
                      ? _c("card-info-component", {
                          staticClass: "mr-4",
                          attrs: {
                            title: _vm.$t(
                              "pages.planning.widgets.hour_balance"
                            ),
                            value: _vm.employeeHours,
                            "is-loading": _vm.initializing,
                          },
                        })
                      : _vm._e(),
                    _c("card-info-component", {
                      attrs: {
                        title: _vm.$t("pages.dashboard.widgets.vacation_days"),
                        value: _vm.employeeDayVacations,
                        "is-loading": _vm.initializing,
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("vue-button", {
                        staticClass: "btn btn-secondary m-2 float-right",
                        attrs: {
                          title: _vm.$t(
                            "pages.planing-team-validate.add_overtime"
                          ),
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.addOvertime.apply(null, arguments)
                          },
                        },
                      }),
                      _c("vue-button", {
                        staticClass: "btn btn-secondary m-2 float-right",
                        attrs: {
                          title: _vm.$t(
                            "pages.planing-team-validate.add_workshift"
                          ),
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.addWorkShift.apply(null, arguments)
                          },
                        },
                      }),
                      _c("vue-button", {
                        staticClass: "btn btn-secondary m-2 float-right",
                        attrs: {
                          title: _vm.$t(
                            "pages.planing-team-validate.add_absence"
                          ),
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.addAbsence.apply(null, arguments)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "row mb-2 mt-2" }, [
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "div",
                      { staticClass: "card box-shadow employee-data" },
                      [
                        _c("div", { staticClass: "card-body p-0" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-md-5" }, [
                              _c("div", { staticClass: "form-group m-3" }, [
                                _c(
                                  "label",
                                  { staticClass: "label-description" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "pages.planing-team-validate.employee_name"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c("div", [
                                  _c("div", { staticClass: "description" }, [
                                    _vm._v(_vm._s(_vm.employeeName)),
                                  ]),
                                ]),
                              ]),
                            ]),
                            _c("div", { staticClass: "col-md-2" }, [
                              _c("div", { staticClass: "form-group m-3" }, [
                                _c(
                                  "label",
                                  { staticClass: "label-description" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "pages.planing-team-validate.employee_id"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c("div", [
                                  _c("div", { staticClass: "description" }, [
                                    _vm._v(_vm._s(_vm.employeeCode)),
                                  ]),
                                ]),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "card box-shadow" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c("div", { staticClass: "row mb-3" }, [
                          _c(
                            "div",
                            { staticClass: "col col-sm-8 col-md-8 col-lg-8" },
                            [
                              _c("suc-date-period-component", {
                                attrs: { type: _vm.typePeriod },
                                on: _vm._d({}, [
                                  _vm.datePeriodChangedEvent,
                                  _vm.datePeriodChanged,
                                ]),
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col col-sm-4 col-md-4 col-lg-4 text-right",
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "p-0 pl-2 float-right btn-refresh",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.init.apply(null, arguments)
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "fas fa-sync-alt" })]
                              ),
                            ]
                          ),
                        ]),
                        _c(
                          "article",
                          {
                            staticClass: "data-load",
                            class: { "sk-loading": _vm.initializing },
                          },
                          [
                            _c("h3", { staticClass: "mb-4" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("pages.planing-team-validate.data")
                                  ) +
                                  " "
                              ),
                              _vm.activeHourForApprove
                                ? _c("span", { staticClass: "float-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "pages.planing-team-validate.real"
                                        ) +
                                          ": " +
                                          _vm.summaryDayApprovedHour +
                                          "h"
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm.initializing ? _c("sk-spinner") : _vm._e(),
                            _c("suc-vertical-table-component", {
                              attrs: {
                                "row-headers": _vm.rowHeaders,
                                columnsData: _vm.columnsData,
                                cells: _vm.cells,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "cell",
                                    fn: function (props) {
                                      return [
                                        props.cell.key === "weekDayName"
                                          ? [
                                              _c(
                                                "span",
                                                {
                                                  class: {
                                                    "week-end":
                                                      props.cell.column.data.day
                                                        .weekend,
                                                    "font-weight-bold": true,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(props.cell.value)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : "dayType" === props.cell.key
                                          ? [
                                              _c(
                                                "plan-week-or-monthItem-table-component",
                                                {
                                                  attrs: {
                                                    employeeData:
                                                      props.cell.column.data
                                                        .employeePlan,
                                                    employee:
                                                      _vm.employeePlanData
                                                        .employee,
                                                  },
                                                }
                                              ),
                                            ]
                                          : props.cell.key === "date" &&
                                            props.cell.value !==
                                              props.cell.defaultValue
                                          ? [
                                              _c("formatted-date-component", {
                                                staticClass:
                                                  "font-weight-light font-weight-italic",
                                                attrs: {
                                                  val: props.cell.value,
                                                  onlyDay: true,
                                                },
                                              }),
                                            ]
                                          : "planned" === props.cell.key &&
                                            props.cell.value !==
                                              props.cell.defaultValue &&
                                            !props.cell.column.data.fired
                                          ? [
                                              _c("formatted-number-component", {
                                                class: ["planned-hour"],
                                                attrs: {
                                                  val: props.cell.value,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.plannedHourClicked(
                                                      props.cell.column.data
                                                        .employeePlan
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          : "biometric" === props.cell.key &&
                                            props.cell.value !==
                                              props.cell.defaultValue &&
                                            !props.cell.column.data.employeePlan
                                              .fired
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "hour-biometric",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.addBiometricHours(
                                                        props.cell.column.data
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  props.cell.column.data
                                                    .biometric.isValid &&
                                                  parseInt(
                                                    props.cell.column.data
                                                      .biometric.totalMinutes
                                                  ) <= 1440
                                                    ? _c("img", {
                                                        attrs: {
                                                          src: require("@/assets/IC_Msg_Sucess.png"),
                                                          alt: "valid",
                                                        },
                                                      })
                                                    : _c("img", {
                                                        attrs: {
                                                          src: require("@/assets/IC_Msg_Alert.png"),
                                                          alt: "warning",
                                                        },
                                                      }),
                                                  _c(
                                                    "formatted-number-component",
                                                    {
                                                      attrs: {
                                                        val: props.cell.value,
                                                      },
                                                    }
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "row text-left",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "col-4",
                                                        },
                                                        [
                                                          _c("img", {
                                                            attrs: {
                                                              src: require("@/assets/IC_plan_biometrico_secondary_white.svg"),
                                                              alt: "icon",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-8 text-right",
                                                        },
                                                        [
                                                          _c(
                                                            "formatted-minutes-component",
                                                            {
                                                              attrs: {
                                                                val: props.cell
                                                                  .column.data
                                                                  .biometric
                                                                  .totalMinutes,
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          : _vm._e(),
                                        props.cell.key === "real" &&
                                        props.cell.value !==
                                          props.cell.defaultValue &&
                                        !props.cell.column.data.employeePlan
                                          .fired
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "hour-real",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.addRealHours(
                                                        props.cell.column.data
                                                          .employeePlan
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "formatted-number-component",
                                                    {
                                                      attrs: {
                                                        val: props.cell.value,
                                                      },
                                                    }
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          : _vm._e(),
                                        props.cell.key === "actions" &&
                                        _vm.$isset(
                                          props.cell.column.data.employeePlan
                                            .key
                                        ) &&
                                        !props.cell.column.data.employeePlan
                                          .fired
                                          ? [
                                              _c("div", [
                                                _vm.activeBiometric
                                                  ? _c("img", {
                                                      staticClass: "mx-2",
                                                      attrs: {
                                                        src: require("@/assets/IC_plan_biometrico_secondary.svg"),
                                                        alt: "action",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.acceptBiometric(
                                                            props.cell
                                                          )
                                                        },
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm.activeHourForApprove
                                                  ? _c("img", {
                                                      staticClass: "mx-2",
                                                      attrs: {
                                                        src: require("@/assets/IC_plan_planeado.svg"),
                                                        alt: "action",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.acceptPlanned(
                                                            props.cell
                                                          )
                                                        },
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ]),
                                            ]
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2006173307
                              ),
                            }),
                            _vm.showAcceptAllButtons
                              ? _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col text-right" },
                                    [
                                      _vm.activeBiometric
                                        ? _c("vue-button", {
                                            staticClass:
                                              "button-secondary-outline my-1",
                                            attrs: {
                                              title: "ACEPTAR BIOMETRICOS",
                                              uppercase: true,
                                            },
                                            on: {
                                              click: _vm.acceptAllBiometrics,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "body-icon",
                                                  fn: function () {
                                                    return [
                                                      _c("img", {
                                                        attrs: {
                                                          src: require("@/assets/IC_plan_biometrico_secondary.svg"),
                                                          alt: "icon",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              1030139527
                                            ),
                                          })
                                        : _vm._e(),
                                      _vm.activeHourForApprove
                                        ? _c("vue-button", {
                                            staticClass:
                                              "btn-primary my-1 ml-3",
                                            attrs: {
                                              title: "Acceptar Planejat",
                                              uppercase: true,
                                            },
                                            on: { click: _vm.acceptAllPlanned },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "body-icon",
                                                  fn: function () {
                                                    return [
                                                      _c("img", {
                                                        attrs: {
                                                          src: require("@/assets/IC_plan_planeado_white.svg"),
                                                          alt: "icon",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              2484404073
                                            ),
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c("set-biometric-hour-modal", { on: { changed: _vm.init } }),
      _c("set-real-hour-modal", { on: { changed: _vm.init } }),
      _c("copy-hour-confirm-modal", { on: { changed: _vm.init } }),
      _c("add-work-shift-modal", { on: { changed: _vm.init } }),
      _c("add-absence-modal", { on: { changed: _vm.init } }),
      _c("set-planning-hour-modal", { on: { changed: _vm.init } }),
      _c("add-overtime-modal", { on: { changed: _vm.init } }),
      _c("edit-overtime-modal", { on: { changed: _vm.init } }),
      _c("work-shift-detail-modal"),
      _c("day-detail-component"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }